import axios from "axios";

export const getAuthConfigAndCompanyId = (state) => {
  const sharedUserInfotoken = state?.sharedLogin?.sharedUserInfo;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `${sharedUserInfotoken?.payload?.token}`,
    },
  };

  let companyId;
  if (sharedUserInfotoken?.payload?.company) {
    companyId = sharedUserInfotoken?.payload?.company?._id;
  } else if (
    sharedUserInfotoken?.empCompanies &&
    sharedUserInfotoken?.empCompanies.length > 0
  ) {
    companyId = sharedUserInfotoken?.empCompanies[0]?.companyId?._id;
  }

  return { companyId, config };
};

export const handleApiError = (error) => {
  let err =
    error.response &&
    (typeof error.response.data === "string"
      ? error.response.data
      : error.response.data.message
      ? error.response.data.message
      : error.response.data.errors
      ? error.response.data.errors[0].msg
      : error?.message);

  if (!err) {
    err = "Network Error";
  }

  return err;
};

/**
 * Make authenticated API request with automatic error handling
 * @param {Function} apiCall - Function that makes the API call
 * @param {Function} dispatch - Redux dispatch function
 * @param {Object} requestType - Redux action type for request
 * @param {Object} successType - Redux action type for success
 * @param {Object} failType - Redux action type for failure
 * @param {Function} getState - Redux getState function
 * @returns {Promise} - Promise that resolves with API response or rejects with error
 */
export const makeAuthenticatedRequest = async (
  apiCall,
  dispatch,
  requestType,
  successType,
  failType,
  getState
) => {
  try {
    dispatch({ type: requestType });

    const { companyId, config } = getAuthConfigAndCompanyId(getState());

    const response = await apiCall(companyId, config);

    dispatch({
      type: successType,
      payload: response.data?.data || response.data,
    });

    return response;
  } catch (error) {
    const errorMessage = handleApiError(error);

    dispatch({
      type: failType,
      payload: errorMessage,
    });

    throw errorMessage;
  }
};


